import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { compare, type Operation } from 'fast-json-patch'

import FormSection from '../../../../formSection/FormSection'
import { SwitchInput } from '../../../../input/switchInput/SwitchInput'

import {
  NotificationsModel,
  UserProfile,
} from '../../../../../types/user/userProfile'

type NotificationsFormProps = {
  profile: UserProfile | null
  loading: boolean
  onSave: (patch: Operation[]) => Promise<void> | void
}

const NotificationsForm = ({
  profile,
  loading,
  onSave,
}: NotificationsFormProps) => {
  const { t } = useTranslation('account')

  const [notifications, setNotifications] = useState<NotificationsModel>({
    emailNotifications: false,
    pushNotifications: false,
    marketingNotifications: false,
  })

  useEffect(() => {
    if (!profile) {
      return
    }

    setNotifications({
      emailNotifications: profile.emailNotifications,
      pushNotifications: profile.pushNotifications,
      marketingNotifications: profile.marketingNotifications,
    })
  }, [profile])

  const handleSwitchChange = (name: string, checked: boolean) => {
    if (!(name in notifications)) {
      return
    }

    const updatedNotifications = {
      ...notifications,
      [name]: checked,
    }
    const patch = compare(notifications, updatedNotifications)

    setNotifications(updatedNotifications)

    if (patch.length > 0) {
      onSave(patch)
    }
  }

  return (
    <FormSection title={t('account.notifications.title')}>
      <div className="row">
        <div className="col-12">
          <SwitchInput
            name="emailNotifications"
            label={t('account.notifications.email.title')}
            description={t('account.notifications.email.description')}
            checked={notifications.emailNotifications}
            disabled={loading}
            onChange={handleSwitchChange}
          />
        </div>
        <div className="col-12">
          <SwitchInput
            name="pushNotifications"
            label={t('account.notifications.push.title')}
            description={t('account.notifications.push.description')}
            checked={notifications.pushNotifications}
            disabled
            onChange={handleSwitchChange}
          />
        </div>
        <div className="col-12">
          <SwitchInput
            name="marketingNotifications"
            label={t('account.notifications.marketing.title')}
            description={t('account.notifications.marketing.description')}
            checked={notifications.marketingNotifications}
            disabled={loading}
            onChange={handleSwitchChange}
          />
        </div>
      </div>
    </FormSection>
  )
}

export default NotificationsForm
